import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { CaseFormEntity } from '../../../domain/entities/case-form.entity';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';
import { GetCaseFormsByCaseTypeQuery } from './get-case-forms-by-case-type.query';

/**
 * Get Case Forms By Case Type Use Case
 * Retrieves all case forms associated with a specific case type and updates state
 * Note: Typically there should be only one form per case type (1:1 relationship)
 */
@Injectable({ providedIn: 'root' })
export class GetCaseFormsByCaseTypeUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);

  public execute(query: GetCaseFormsByCaseTypeQuery): Observable<CaseFormEntity[]> {
    this._state.setLoadingCaseForms(true);
    this._state.clearErrorCaseForms();

    return this._repository.getCaseFormsByCaseTypeId(query.caseTypeId).pipe(
      tap((caseForms) => {
        // Update state with filtered forms
        this._state.setCaseForms(caseForms);
      }),
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message ||
          `Failed to load case forms for case type ${query.caseTypeId}`;
        this._state.setErrorCaseForms(errorMessage);
        throw error;
      }),
      finalize(() => this._state.setLoadingCaseForms(false))
    );
  }
}
